<template>
  <modal
    :name="name"
    height="auto"
    adaptive
  >
    <div class="modal-inner">
      <slot/>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    name: String,
  },
};
</script>

<style lang="scss">
.form-group {
  display: block;
  text-align: left;
  margin-bottom: 20px;
  .form-label {
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
  }
  .form-control {
    font-size: 16px;
    padding: 8px 12px;
    width: 100%;
    border: 1px solid $gray-300;
    &:focus {
      outline: none;
      box-shadow: 0 0 0 4px rgba($primary, 0.2);
    }
  }
}
</style>
